import { Dict } from 'styled-components/dist/types';

interface ItemsProps {
    permissions: string[];
    paths: string[];
    to?: string;
}

export const ITEMS = {
    dashboard: {
        permissions: ['view_dashboard_extra'],
        paths: ['/dashboard'],
        to: '/dashboard'
    },
    user: {
        permissions: ['view_user'],
        paths: ['/users'],
        to: '/users'
    },
    group: {
        permissions: ['view_group'],
        paths: ['/roles'],
        to: '/roles'
    },
    preference: {
        permissions: ['view_preference'],
        paths: ['/preferences'],
        to: '/preferences'
    },
    eventRepresentation: {
        permissions: ['view_eventrepresentation'],
        paths: ['/event-representations'],
        to: '/event-representations'
    },
    eventObjective: {
        permissions: ['view_eventobjective'],
        paths: ['/event-objectives'],
        to: '/event-objectives'
    }
};

export const MENU_ITEMS = {
    //***** Configuration  submenu
    configuration_single_items: {
        permissions: [
            ...ITEMS.user.permissions,
            ...ITEMS.group.permissions
        ],
        paths: [
            ...ITEMS.user.paths,
            ...ITEMS.group.paths
        ]
    },
    //***** Events submenu
    events_items: {
        permissions: [
            ...ITEMS.preference.permissions,
            ...ITEMS.eventRepresentation.permissions,
            ...ITEMS.eventObjective.permissions
        ],
        paths: [
            ...ITEMS.preference.paths,
            ...ITEMS.eventRepresentation.paths,
            ...ITEMS.eventObjective.paths
        ]
    }
};

const configuration_module: ItemsProps[] = [MENU_ITEMS.configuration_single_items];
const events_module: ItemsProps[] = [MENU_ITEMS.events_items];

export const PERMISSIONS_APP = {
    configuration: configuration_module,
    events: events_module
};

export const verify_permission = (
    modulePermissions: ItemsProps[],
    permissionsUser: Array<string>
) => {
    for (const module of modulePermissions) {
        for (const userPermission of permissionsUser) {
            if (module.permissions.includes(userPermission)) {
                return true;
            }
        }
    }
    return false;
};

export const verify_path = (modulePaths: string[], pathname: string) => {
    if (modulePaths.some((path) => pathname.includes(path))) {
        return true;
    }

    return false;
};
